import './uncontrolled-new-converge-input-label.scss';

import * as Yup from 'yup';

import { Dispatch, FC, SetStateAction } from 'react';

import { FormFieldContainer } from './form-field-container';
import { IFormNumberFieldProps } from './form-number-field';
import InputAdornment from '@mui/material/InputAdornment';
import { OutlinedInput } from '@mui/material';

export interface IUncontrolledNewFormNumberInputAdornmentField
  extends IFormNumberFieldProps {
  adornmentPosition?: 'start' | 'end';
  adornmentText: string;
  width?: string;
  isCheckBox?: boolean;
  dataTestid?: string;
  name: string;
  setGbeQuotaShareValue: Dispatch<SetStateAction<number>>;
  setCanopiusShareValue: Dispatch<SetStateAction<number>>;
  handleDebouncedAutoSave: () => void;
}

const validateNumber = (value: number | null): boolean => {
  const schema = Yup.number()
    .nullable()
    .optional()
    .typeError('Enter Number')
    .min(0, 'Enter 0-100')
    .max(100, 'Enter 0-100');

  try {
    schema.validateSync(value);
    return true;
  } catch (error) {
    return false;
  }
};
export const UncontrolledNewFormNumberInputAdornmentField: FC<
  IUncontrolledNewFormNumberInputAdornmentField
> = ({
  adornmentPosition = 'start',
  isCheckBox,
  adornmentText,
  name,
  handleDebouncedAutoSave,
  width,
  setCanopiusShareValue,
  setGbeQuotaShareValue,
  ...otherProps
}) => {
  return (
    <FormFieldContainer md={12} className="form-container-field">
      <OutlinedInput
        sx={{
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#23a892',
          },
          '&.Mui-disabled': {
            backgroundColor: '#f5f5f5',
            color: '#a0a0a0',
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: '#d3d3d3',
            },
            '& .MuiInputAdornment-root': {
              backgroundColor: '#f5f5f5', // match disabled input background
              color: '#a0a0a0', // optional, for adornment text
            },
          },
          '&.Mui-disabled:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#d3d3d3',
          },
          width: '80px',
          height: '40px',
        }}
        id="outlined-adornment-weight"
        endAdornment={
          <InputAdornment position="end">{adornmentText}</InputAdornment>
        }
        aria-describedby="outlined-weight-helper-text"
        disabled={isCheckBox}
        inputProps={{
          'aria-label': 'weight',
        }}
        onChange={(v) => {
          const value = +v.target.value; // Convert to number only once
          if (validateNumber(value)) {
            if (name === 'canopiusShare') {
              setCanopiusShareValue(value);
              setGbeQuotaShareValue(100 - value);
            } else {
              setGbeQuotaShareValue(value);
              setCanopiusShareValue(100 - value);
            }
          } else {
            // Handle invalid input, e.g., reset to previous value or show an error message
            console.error('Invalid number input');
          }
        }}
        onBlur={() => handleDebouncedAutoSave()}
        value={otherProps.value}
      />
    </FormFieldContainer>
  );
};
